import { Record } from "immutable";
import { AnyAction } from "redux";

import { ServiceLocationState } from "@typings/serviceLocation";
import { LOADING_STATE } from "@typings/reduxThunkActions";

import {
  ACTION_FAIL,
  ACTION_PENDING,
  ACTION_SUCCESS,
} from "@services/AsyncActionCreatorFactory";

import {
  FETCH_SERVICE_LOCATION_COVERAGE,
  FETCH_SERVICE_LOCATION,
  SET_FROM_LOCAL_STORAGE,
  RESET_STATE,
} from "./serviceLocation.actions";
import { ServiceLocationParams } from "./serviceLocation.typings";

const initialState = Record<ServiceLocationState>({
  zip: "",
  city: "",
  hideCityName: false,
  bookingUrl: "",
  serviceTypes: [],
  loadingState: LOADING_STATE.IDLE,
});

const serviceLocationReducer = (
  store: Record<ServiceLocationState> = initialState(),
  action: AnyAction,
): Record<ServiceLocationState> => {
  const { type, payload } = action;
  const params = action.params as ServiceLocationParams;

  switch (type) {
    case SET_FROM_LOCAL_STORAGE: {
      return action.payload || store;
    }
    case `${FETCH_SERVICE_LOCATION}${ACTION_SUCCESS}`: {
      return store.merge(payload.data);
    }
    case `${FETCH_SERVICE_LOCATION_COVERAGE}${ACTION_PENDING}`: {
      return store.set("loadingState", LOADING_STATE.LOADING);
    }
    case `${FETCH_SERVICE_LOCATION_COVERAGE}${ACTION_SUCCESS}`: {
      if (!params?.saveData) {
        return store;
      }

      const { bookingUrl, city, hideCityName, serviceTypes, zip } =
        payload.data;

      return store.merge({
        bookingUrl,
        city,
        hideCityName,
        serviceTypes,
        zip,
        loadingState: LOADING_STATE.SUCCEEDED,
      });
    }
    case `${FETCH_SERVICE_LOCATION_COVERAGE}${ACTION_FAIL}`: {
      return store.set("loadingState", LOADING_STATE.FAILED);
    }
    case RESET_STATE: {
      return initialState();
    }
    default: {
      return store;
    }
  }
};

export { serviceLocationReducer };
